<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#6783B2">
        <path
          d="M14.5 8c.276 0 .5.224.5.5 0 4.142-3.358 7.5-7.5 7.5-2.17 0-4.131-1.04-5.5-2.775V15.5c0 .245-.177.45-.41.492L1.5 16c-.245 0-.45-.177-.492-.41L1 15.5v-4.014c0-.017.002-.035.004-.052L1 11.5c0-.035.004-.07.01-.103l.012-.045.014-.039c.007-.018.016-.036.025-.053l.012-.02.027-.04.027-.033c.008-.01.017-.018.026-.027.012-.012.024-.022.037-.032l.03-.023.044-.026.014-.007.02-.01.045-.017-.065.027c.037-.018.076-.032.115-.04l.017-.004.013-.002.06-.006H5.5c.276 0 .5.224.5.5 0 .245-.177.45-.41.492L5.5 12H2.355c1.19 1.87 3.06 3 5.145 3 3.59 0 6.5-2.91 6.5-6.5 0-.276.224-.5.5-.5zm-1-8c.245 0 .45.177.492.41L14 .5v4.022l-.004.038L14 4.5c0 .035-.004.07-.01.103l-.012.045-.014.039-.021.045-.016.029-.027.04-.027.032c-.008.01-.017.018-.026.027-.012.012-.024.022-.037.032l-.03.023-.044.026-.014.007-.02.01-.045.017.065-.027c-.037.018-.076.032-.115.04l-.017.004-.015.002c-.016.003-.032.005-.048.005L13.5 5h-4c-.276 0-.5-.224-.5-.5 0-.245.177-.45.41-.492L9.5 4h3.145c-1.19-1.87-3.06-3-5.145-3C3.91 1 1 3.91 1 7.5c0 .276-.224.5-.5.5S0 7.776 0 7.5C0 3.358 3.358 0 7.5 0c2.171 0 4.132 1.04 5.5 2.776V.5c0-.245.177-.45.41-.492L13.5 0z"
          transform="translate(1)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'RefreshIcon',
  props: {
    height: VueTypes.string.def('16'),
    width: VueTypes.string.def('16'),
  },
};
</script>

<style lang="scss"></style>
